import { useEffect, useCallback } from "react";

export const useInfiniteScroll = (
  listRef: React.RefObject<HTMLDivElement | null>,
  fetchNextPage: () => void,
  hasNextPage: boolean | undefined,
  isFetchingNextPage: boolean,
  data: any,
  threshold: number = 5 // расстояние от конца для загрузки
) => {
  const handleScroll = useCallback(() => {
    if (listRef && listRef.current && hasNextPage && !isFetchingNextPage) {
      const { scrollTop, scrollHeight, clientHeight } = listRef.current;
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - threshold;

      if (isNearBottom) {
        fetchNextPage();
      }
    }
  }, [listRef, hasNextPage, isFetchingNextPage, fetchNextPage, threshold]);

  // Автопроверка после загрузки данных
  useEffect(() => {
    handleScroll();
  }, [data, handleScroll]);

  return handleScroll;
};
